export const makeWordEnding = (value: number): string => {
  let charEnding = 'ів';

  if (value % 10 === 1) {
    charEnding = '';
  }

  if (value % 10 > 1 && value % 10 < 5) {
    charEnding = 'а';
  }

  if (value % 100 > 10 && value % 100 < 19) {
    charEnding = 'ів';
  }

  return charEnding;
}
